// extracted by mini-css-extract-plugin
export var addToCartButton = "_pg-b";
export var arrowButtonContainer = "_pg-9";
export var arrowButtonIcon = "_pg-a";
export var carouselArrowButton = "_pg-6";
export var carouselElementContainer = "_pg-1";
export var galleryThumbnail = "_pg-d";
export var galleryThumbnailImage = "_pg-e";
export var left = "_pg-7";
export var productDisplayCarouselContainer = "_pg-0";
export var productTileContainer = "_pg-2";
export var productTileImage = "_pg-4";
export var productTileImageContainer = "_pg-3";
export var productTileTitle = "_pg-5";
export var right = "_pg-8";
export var sliderOverflow = "_pg-c";